import { render, staticRenderFns } from "./LotsList.vue?vue&type=template&id=55464952&scoped=true"
import script from "./LotsList.vue?vue&type=script&lang=js"
export * from "./LotsList.vue?vue&type=script&lang=js"
import style0 from "./LotsList.vue?vue&type=style&index=0&id=55464952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55464952",
  null
  
)

export default component.exports